<vpfa-text-field
  #input
  [parentFormGroup]="formGroup"
  (fieldBlur)="onBlur()"
  fcName="field"
></vpfa-text-field>
